import { AnaColumn } from "../forms-template.service";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";

export const AutorizzazioneAreaCer: AnaColumn[] = [
  {
    itemType: "group", class: '', colCount: "1", data: [
      { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },

      { type: 'campo', dataField: "idAutorizzazioneArea", colVisible: false, disableOnUpdate: true },
      {
        type: 'campo', dataField: "index", caption: ' ', allowEditing: false, colVisible: true, disableOnUpdate: true, hideOnEdit: true,
        class: 'indexClass', colWidth: '70px',
      },

      {
        type: 'campoSpecial',
        dataField: 'cer',
        dataType: '',
        caption: 'EER',
        colVisible: true,
        colWidth: '100px',
        labelVisible: true,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ],
        dynamic: {
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          filterStatic: "?$filter=(not endswith(id,'00'))",
          valueExpr: 'id',
          displayExpr: 'id', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista Eer',
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid: {
            campoTabRif: '', 
            masterKey: 'id',
            keyUnique: '',
            mode:'cell',
            selectionMode: 'single',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            height:700,
            width:800,
            showColBlank:false,
            showFilterSearch:false

          }
        }
      },



      {
        type: 'campoSpecial',
        dataField: 'listaModStoccaggio',
        dataType: '',
        caption: 'Modalità di Stoccaggio',
        colWidth: '630px',
        colVisible: true,
        labelVisible: true,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: '',
          autocomplete: false,
          dataFormFilter: 'listaModStoccaggio',//il campo proveniente dalla form per filtrare il dataSource 
          valueExpr: '',
          displayExpr: 'id', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista operazione smaltimento',
          componentType: 'dynamicGrid',
         
          buttonOption: {
            text: 'Codici Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista modalità di smaltimento',
            name: 'CodiciStoccaggioLista',
            location: 'after',
          },
          settingGrid:  {
          
            campoTabRif: '', 
            masterKey: 'id',
            keyUnique: '',
            mode:'cell',
            selectionMode: 'multiple',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            height:700,
            width:800,
            showColBlank:false,
            showFilterSearch:false,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true
              },

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Operazione',

                hideOnEdit: false
              },

            ],
          }
          
         
        }
      },

     


      {
        type: 'campoSpecial',
        dataField: 'listaModTrattamento',
        dataType: '',
        caption: 'Modalità di trattamento',
        orderGriglia: 1,
        colVisible: true,
        colWidth: '630px',
        labelVisible: true,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: '',
          autocomplete: false,
          dataFormFilter: 'listaModTrattamento',//il campo proveniente dalla form per filtrare il dataSource 
         
          valueExpr: '',
          displayExpr: 'id', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista operazione trattamento',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Codici Trattamento',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista modalità di trattamento',
            name: 'CodiciTrattamentoLista',
            location: 'after',
          },
          settingGrid:  {
          
            campoTabRif: '', 
            masterKey: 'id',
            keyUnique: '',
            mode:'cell',
            selectionMode: 'multiple',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            height:700,
            width:800,
            showColBlank:false,
            showFilterSearch:false,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true
              },

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Operazione',

                hideOnEdit: false
              },

            ],
          }
          
        }
      },
    ]
  },

]
export const AutorizzazioneAreaCer2: AnaColumn[] = [
  {
    itemType: "group", class: '', colCount: "1", data: [
      { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },

      { type: 'campo', dataField: "idAutorizzazioneArea", colVisible: false, disableOnUpdate: true },
      
      {
        type: 'campoSpecial',
        dataField: 'cer',
        dataType: '',
        caption: 'EER',
        showClearButton:false,
        colVisible: true,
        colWidth: '70',
        labelVisible: true,
        maxLength:6,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ],
       
        dynamic: {
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          queryString: "?$filter=(not endswith(id,'00'))",
          valueExpr: 'id',
          displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista E.E.R.',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },
      
      {
        type: 'campoSpecial',
        dataField: 'listaModStoccaggio',
        dataType: '',
        caption: 'Modalità di Stoccaggio',
        disableOnUpdate:true,
        colVisible: true,
        
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: '',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: 'Lista operazione smaltimento',
          componentType: 'dynamicGrid',
          
          buttonOption: {
            text: 'Codici Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista modalità di smaltimento',
            name: 'CodiciStoccaggioLista',
            location: 'after',
          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              overrideDataSource:'listaModStoccaggioGeneric',
              /* concatDataField:'listaModStoccaggio', */
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },

     

      {
        type: 'campoSpecial',
        dataField: 'listaModTrattamento',
        dataType: '',
        caption: 'Modalità di trattamento',
        orderGriglia: 1,
        colVisible: true,
        disableOnUpdate:true,
        labelVisible: true,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: '',
          autocomplete: false,
          
          valueExpr: '',
          displayExpr: 'id', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista operazione trattamento',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Codici Trattamento',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista modalità di trattamento',
            name: 'CodiciTrattamentoLista',
            location: 'after',
          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              overrideDataSource:'listaModTrattamentoGeneric',
             
              /* concatDataField:'listaModStoccaggio', */
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },
    ]
  },

]